import type { ReactElement } from "react"
import React from "react"
import ToggleSectionContainerOrg from "@onestore/hel/dist/components/organisms/ToggleSectionContainerOrg"
import type { ProductCardItem } from "@gatsby-plugin-marketplace/fragments/marketplaceProductCard"
import ProductCardsTemplate from "~/templates/ProductCardsTemplate"

interface ProductSliderProps {
  products: ProductCardItem[]
  title: string
}

export default function ProductSlider({
  products,
  title,
}: ProductSliderProps): ReactElement<ProductSliderProps> | null {
  return (
    <ToggleSectionContainerOrg
      color="light"
      heading={title}
      spacing="small"
      hasOverflowHidden
    >
      <ProductCardsTemplate products={products} />
    </ToggleSectionContainerOrg>
  )
}
